<template>
  <div>
    <svg
      width="390"
      height="64"
      viewBox="0 0 390 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="mobile"
    >
      <path
        d="M0 64H390V54.782C390 11.9572 341.618 2.38291 303.64 7.37784C258.527 13.3119 60.0841 43.7668 60.0841 43.7668C30.6953 48.7184 13.1507 54.0319 0 64Z"
        fill="currentColor"
      />
    </svg>

    <svg
      width="768"
      height="96"
      viewBox="0 0 768 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="tablet"
    >
      <path
        d="M0 95.9995H768V82.1725C768 17.9353 672.726 3.57387 597.937 11.0663C509.1 19.9674 118.319 65.6497 118.319 65.6497C60.4462 73.0772 25.8968 81.0473 0 95.9995Z"
        fill="currentColor"
      />
    </svg>

    <svg
      width="1440"
      height="160"
      viewBox="0 0 1440 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="desktop"
    >
      <path
        d="M1440 160V136.954C1440 29.8925 1261.36 5.95678 1121.13 18.4441C954.562 33.2793 221.849 109.417 221.849 109.417C113.337 121.796 48.5565 135.079 0 160H1440Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'BrushStroke'
  }
</script>
